/**
 * web.service.ts
 * Copyright (c) 2016 Taillight LLC
 */

import { Injectable } from '@angular/core';
import { AuthenticationModel } from '../../models/user.auth';
import { UserAccount } from '../../models/user.account';
const USER_TOKEN_KEY = 'im_token_key'
const USER_AUTHINFO_KEY = 'im_authinfo_key'
const USER_PROVIDERID_KEY = 'im_providerid_key'
const USER_ISADMIN_KEY = 'im_portaladmin_key'
const USER_OBJ_KEY = 'im_useraccount_key'
const PROVNAME_KEY = 'im_provname_key'
const DEALERSHIP_EXP_DATE = 'im_dealership_expiration_date'
const OLD_ACCOUNT_KEY = 'core_account_info_key'
const OLD_ACCOUNT_MODE_KEY = 'core_account_mode_key'
const CORE_REDIRECTED_APP = 'core_app_key'

// TODO - Fix the null traps
@Injectable()
export class SessionVariablesUtility {
    constructor() {
    }

    public getCurrentUserToken(): string {
        const iamToken = sessionStorage.getItem(USER_TOKEN_KEY);
        return iamToken === 'null' ? null : iamToken;
    }

    public setCurrentUserToken(tok: string): void {
        sessionStorage.setItem(USER_TOKEN_KEY, tok);
    }

    public setCurrentAuthInfo(authInfo: AuthenticationModel): void {
        sessionStorage.setItem(USER_AUTHINFO_KEY, JSON.stringify(authInfo));
    }

    public getCurrentAuthInfo(): AuthenticationModel {
        let s = sessionStorage.getItem(USER_AUTHINFO_KEY);
        return s != null && s.length > 0 ? JSON.parse(s) as AuthenticationModel : null;
    }

    public getCurrentUserProviderId(): string {
        return this.getLoggedInUser() ? this.getLoggedInUser().PrimaryProviderId : null;
    }

    public setUserIsPortalAdmin(isAdmin: boolean): void {
        sessionStorage.setItem(USER_ISADMIN_KEY, isAdmin ? 'true' : 'false');
    }

    public setProviderName(provname: string): void {
        sessionStorage.setItem(PROVNAME_KEY, provname);
    }

    public getUserIsPortalAdmin(): boolean {
        return sessionStorage.getItem(USER_ISADMIN_KEY) === 'true';
    }

    public setLoggedInUser(usr: UserAccount) {
        sessionStorage.setItem(USER_OBJ_KEY, JSON.stringify(usr));
    }

    public getLoggedInUser(): UserAccount {
        return JSON.parse(sessionStorage.getItem(USER_OBJ_KEY));
    }

    public getProviderName(): string {
        return sessionStorage.getItem(PROVNAME_KEY);
    }

    public setExpirationDate(expDate: string) {
        sessionStorage.setItem(DEALERSHIP_EXP_DATE, expDate);
    }

    public getExpirationDate(): string {
        return sessionStorage.getItem(DEALERSHIP_EXP_DATE);
    }

    public get OldAccountInfo(): any {
        return JSON.parse(sessionStorage.getItem(OLD_ACCOUNT_KEY));
    }

    public set OldAccountInfo(val: any) {
        sessionStorage.setItem(OLD_ACCOUNT_KEY, val ? JSON.stringify(val) : '{}');
    }

    public get CurrentConvertUserMode(): string {
        return sessionStorage.getItem(OLD_ACCOUNT_MODE_KEY) === 'null' ? null : sessionStorage.getItem(OLD_ACCOUNT_MODE_KEY);
    }

    public set CurrentConvertUserMode(val: string) {
        sessionStorage.setItem(OLD_ACCOUNT_MODE_KEY, val);
    }

    public get CoreAppFrom(): string {
        return sessionStorage.getItem(CORE_REDIRECTED_APP) === 'null' ? null : sessionStorage.getItem(CORE_REDIRECTED_APP);
    }

    public set CoreAppFrom(val: string) {
        sessionStorage.setItem(CORE_REDIRECTED_APP, val);
    }
}
